// Labels for the redesigned shell and settings (sooquna-specs/redesign.md).
const redesignEn = {
  "nav.module.commerce": "Commerce",
  "nav.module.people": "People",
  "nav.module.growth": "Growth",
  "nav.module.storefront": "Storefront",
  "nav.module.insights": "Insights",
  "nav.module.finance": "Finance",
  "nav.catalog": "Catalog",
  "nav.stock_levels": "Stock levels",
  "nav.stock_counts": "Stock counts",
  "nav.themes": "Themes",
  "nav.features": "Features",
  "nav.returns": "Returns",
  "nav.reviews": "Reviews",
  "nav.help": "Help",
  "nav.collapse": "Collapse sidebar",
  "nav.expand": "Expand sidebar",
  "nav.breadcrumb": "Breadcrumb",

  "settings.landing_hint": "Manage how your store works, from payments and shipping to your team.",
  "settings.group.business": "Business",
  "settings.group.business_hint": "Store profile, status and policies",
  "settings.group.selling": "Selling",
  "settings.group.selling_hint": "Payments, checkout, shipping and taxes",
  "settings.group.operations": "Operations",
  "settings.group.operations_hint": "Warehouses, inventory, notifications and custom fields",
  "settings.group.privacy": "Customers & Privacy",
  "settings.group.privacy_hint": "Customer accounts and data requests",
  "settings.group.account": "Account",
  "settings.group.account_hint": "Team, subscription, domains and activity",

  "palette.group.pages": "Pages",
  "palette.group.settings": "Settings",
  "palette.group.actions": "Quick actions",
  "palette.action.product": "Create product",
  "palette.action.order": "Create manual order",
  "palette.action.customer": "Add customer",
  "palette.action.collection": "Create collection",
  "palette.action.discount": "Create discount",
  "palette.action.page": "Add page",
  "palette.action.post": "Write blog post",
} as const;

export default redesignEn;
